
import React from "react";
import { checkConditionGroup, checkTranslation, translate } from "../../utils/useful";
import IntractionActionsList from "../../components/IntractionActionsList";

const ContextMenuView = {
    FILE: "file",
    FOLDER: "folder",
    DIRECTORY: "directory",
}



export default class ContextMenu extends React.Component {
    state = {}

    componentDidMount() {
        // console.log('frameeeeis', this.props.frame)
    }
    onOpenItem = () => {
        this.props.onOpenItem(this.props.currentItem)
    }
    actionClicked = (prop, extra) => {
        // console.log('key',key)
        // this.props[key](this.props.currentItem)
        let myExtra = extra
        if (typeof extra == 'object') {
            myExtra = extra ? { ...extra } : {}
            // myExtra.index = this.selectedRowIndex
        }
        this.props.functionsHandler('frame', prop.function, this.props.currentItem, myExtra)

    }
    render() {

        let actions = this.props.page?.actions ?? (this.props.actions ? Object.values(this.props.actions) : [])
        const { show, view, currentItem } = this.props;

        if (show) {
            return (
                <div id='' className="file-manager-context-menu context-close" style={this.props.style} >

                    {Array.isArray(actions) && actions.map((item, index) => {
                        // {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                        // checkPermission
                        // console.log(item)
                        let type = item.type ?? item.key
                        let refAction = this.props.actions[type]
                        let canShow = true
                        let nextStage
                        let lastStage
                        if (type == "nextStage") {
                            if (Array.isArray(this.state.nextStages) && this.state.nextStages?.length > 0) {
                                nextStage = this.state.nextStages.length > 1 ? '' : this.state.nextStages[0]
                            } else {
                                canShow = false
                            }
                        }
                        if (type == "lastStage") {
                            if (Array.isArray(this.state.lastStages) && this.state.lastStages?.length > 0) {
                                lastStage = this.state.lastStages[0]
                            } else {
                                canShow = false
                            }
                        }
                        // console.log(refAction)
                        if (refAction?.conditions) {
                            canShow = checkConditionGroup(refAction.conditions, { data: this.props.currentItem })
                        }
                        // let description = type == "nextStage" ? 'Stage name' : null

                        // let permission = type
                        // if (this.props.actions[type] && (checkPermission(this.props.permissions, `${requiredPermission}.addNewRecord`) && this.props.appletAccess)) {
                        // console.log('this.props.actionslsp',this.props.actions)
                        // console.log('actions',actions)
                        // console.log(canShow, type)
                        if (canShow && this.props.actions[type]) {
                            let prop = this.props.actions[type]
                            return (

                                <div className='w-100 br-4' key={item.key ?? item._id} >
                                    {/* <IntractionActionsList key={index} stage={0} stageName='main' onClick={() => this.props.actionClicked(prop, this.props.data, this.props.index)} language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, icon: prop.icon }} /> */}

                                    <button className="flexcb w-100 hover-gray-no-filter p-2 br-5" onClick={() => this.actionClicked(prop, { action: item, data: this.props.data })}>
                                        <div className='d-flex'>
                                            <div className='flexcc'>
                                                <img className='toolbar-icon flexcc' width={16} height={16} style={{ objectFit: 'contain' }} src={prop.icon} alt='' />
                                            </div>
                                            <div>
                                                <div>
                                                    <p className="font-size-12 mld-3 main-c3 text-start text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(prop.label)}</p>
                                                    {/* {(this.props.description || this.props.data.des) && (
                                                <p className="font-size-10 mld-3 main-c7 text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.description ?? this.props.data.des)}</p>
                                            )} */}
                                                </div>


                                                {(type == "nextStage") && (
                                                    <div className='flexc px-1'>
                                                        <div className='br-20 px-2 py-1 mt-1' style={{ background: nextStage?.color?.background, color: '#000', }}>
                                                            <p className="font-size-10  text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(nextStage?.name)}</p>
                                                        </div>
                                                    </div>
                                                )}

                                                {(type == "lastStage") && (
                                                    <div className='flexc px-1'>
                                                        <div className='br-20 px-2 py-1 mt-1' style={{ background: lastStage?.color?.background ?? 'rgb(241, 234, 255)', color: '#000', }}>
                                                            <p className="font-size-10  text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(lastStage?.name)}</p>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>

                                        </div>



                                        <div className='font-size-10 main-c8'>
                                            {prop.sub == true && (
                                                <img className='flexcc rtl-button rotate-0' width={18} src={"/assets/icons/imports/arrowRight.svg"} />
                                            )}
                                        </div>

                                    </button>




                                </div>
                                // <button onClick={() => this.actionClicked(prop, this.props.data, this.props.index)} className="w-100 p-0 text-start flexc pt-1 mt-1" style={{}}>
                                //     <div className='px-3 flexcb w-100'>

                                //         <p className="text-small text-semibold" style={{ color: prop.color }}>{checkTranslation(prop.label)}</p>
                                //         <div className='flexcc mrd-2'>
                                //             <img src={prop.icon} width={16} />
                                //         </div>
                                //     </div>
                                // </button>

                            )
                        }
                    })}
                </div>
            )
        } else {
            return <></>
        }
    }
}